import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { PopUpHeader } from "./popUpModalHeader";
import { PopUpContent } from "./popUpModalContent";
import { PopUpService } from "../../services/popUpService";
import { IPopUpInfo } from "./interfaces/IPopUpInfo";

export const PopUpModal = () => {
  const [modalIsOpen, setModalIsOpen] = useState(true);
  const [popUpInfo, setPopUpInfo] = useState<IPopUpInfo>();
  const popUpService = new PopUpService();

  const showPopUpAgain = () => {
    popUpService.showPopUpAgain(
      () => {},
      () => {
        console.error("Error: Failed to finish popup");
      }
    );
    setModalIsOpen(false);
  };

  const finishPopUp = () => {
    popUpService.finishPopUp(
      () => {},
      () => {
        console.error("Error: Failed to finish popup");
      }
    );
    setModalIsOpen(false);
  };

  useEffect(() => {
    popUpService.getPopUpInfo(
      (res) => {
        setPopUpInfo(res);
      },
      (res) => console.error(res)
    );

    document.addEventListener("click", (e) => handleClick(e));
  }, []);

  const handleClick = (e: MouseEvent) => {
    if (!checkForClassInPath(e.target, "ReactModal__Content")) {
      showPopUpAgain();
    }
  };

  const checkForClassInPath = (element, className) => {
    if (!element) return false;
    if (element.className && element.className.includes(className)) return true;
    return checkForClassInPath(element.parentNode, className);
  };

  if (popUpInfo) {
    return (
      <Modal
        ariaHideApp={false}
        isOpen={modalIsOpen}
        onRequestClose={showPopUpAgain}
        className="popup-modal-styling"
        overlayClassName="popup-modal-overlay"
      >
        <PopUpHeader hideModal={finishPopUp} />
        <PopUpContent
          contentTitle={popUpInfo.heading}
          contentText={popUpInfo.text}
          contentUrl={popUpInfo.linkUrl}
          contentButtonText={popUpInfo.linkText}
        />
      </Modal>
    );
  } else {
    return null;
  }
};
